import type { AdminScope } from "@/contexts/AuthContext";

export type JwtUserClaims = {
	adminScope?: AdminScope;
	groupId?: string;
	hospitalId?: string;
};

/** Read JWT payload claims on the client (backend still validates the token). */
export function readJwtUserClaims(token: string): JwtUserClaims {
	try {
		const segment = token.split(".")[1];
		if (!segment) return {};
		const json = atob(segment.replace(/-/g, "+").replace(/_/g, "/"));
		const payload = JSON.parse(json) as Record<string, unknown>;
		return {
			adminScope: payload.adminScope as AdminScope | undefined,
			groupId:
				payload.groupId != null ? String(payload.groupId) : undefined,
			hospitalId:
				payload.hospitalId != null ? String(payload.hospitalId) : undefined,
		};
	} catch {
		return {};
	}
}
